import {Order, ProductionStatus} from '../../types';
import { isProductionStatus } from "../order/isProductionStatus";

export function filterByProductionStatus(orders : Order[], status : ProductionStatus, returnRest = false ) : Order[]{
    if(returnRest) return orders.filter(order => !isProductionStatus(order, status))
    return orders.filter(order => isProductionStatus(order, status))
}